import { ref } from 'vue'

// Shared singleton state — true when actively delivering (not idle)
const isDeliveryNavigating = ref(false)

export function useDeliveryMode() {
  return { isDeliveryNavigating }
}
